export type ScreenRouteEntry = { parent?: string; key: string };
export type ScreenRouteMapping = Record<string, ScreenRouteEntry>;

export interface RuntimeParams {
  bookingPageUrl: string;
  managerUrl: string;
}

interface ScreenDefinition {
  parent?: string;
  routeSegments: string[];
  menuKey: (p: RuntimeParams) => string;
}

const screenDefinitions: Record<string, ScreenDefinition> = {
  calendar: {
    routeSegments: ['calendar'],
    menuKey: () => '/calendar',
  },
  'shore-pos': {
    routeSegments: ['shore-pos'],
    menuKey: (p) => p.managerUrl,
  },
  'booking-page': {
    routeSegments: ['booking-page'],
    menuKey: (p) => p.bookingPageUrl,
  },
  'shift-plan': {
    routeSegments: ['shift-plan'],
    menuKey: () => '/shiftplan',
  },
  'management/customers': {
    parent: 'management',
    routeSegments: ['customers'],
    menuKey: () => '/customers',
  },
  'management/resources': {
    parent: 'management',
    routeSegments: ['resources'],
    menuKey: () => '/resources',
  },
  'management/employees': {
    parent: 'management',
    routeSegments: ['hr'],
    menuKey: () => '/hr',
  },
  'management/services': {
    parent: 'management',
    routeSegments: ['services'],
    menuKey: () => '/services',
  },
  'marketing/messenger': {
    parent: 'marketing',
    routeSegments: ['messenger'],
    menuKey: () => '/services#/messenger',
  },
  'marketing/newsletter': {
    parent: 'marketing',
    routeSegments: ['newsletter'],
    menuKey: () => '/newsletter',
  },
  'marketing/feedback': {
    parent: 'marketing',
    routeSegments: ['feedback'],
    menuKey: () => '/feedback',
  },
  'marketing/reminders': {
    parent: 'marketing',
    routeSegments: ['reminders'],
    menuKey: () => '/reminders',
  },
  'analysis/dashboard': {
    parent: 'analysis',
    routeSegments: ['insights'],
    menuKey: () => '/insights',
  },
  'analysis/transactions': {
    parent: 'analysis',
    routeSegments: ['transactions'],
    menuKey: () => '/transactions',
  },
  'analysis/reports': {
    parent: 'analysis',
    routeSegments: ['pos-reports-v2'],
    menuKey: () => '/pos-reports-v2',
  },
  'setup/application-settings': {
    parent: 'setup',
    routeSegments: ['application-settings'],
    menuKey: () => '/application-settings',
  },
  'setup/settings': {
    parent: 'setup',
    routeSegments: ['settings'],
    menuKey: () => '/settings',
  },
  'setup/locations': {
    parent: 'setup',
    routeSegments: ['locations'],
    menuKey: () => '/locations',
  },
};

export function getScreenNameFromRoute(routeFragment: string): string {
  const match = Object.entries(screenDefinitions).find(([, def]) =>
    def.routeSegments.includes(routeFragment)
  );

  return match ? match[0] : routeFragment;
}

export function buildScreenRouteMapping(
  params: RuntimeParams
): ScreenRouteMapping {
  return Object.entries(screenDefinitions).reduce<ScreenRouteMapping>(
    (acc, [screenName, def]) => {
      acc[screenName] = {
        parent: def.parent,
        key: def.menuKey(params),
      };
      return acc;
    },
    {}
  );
}

export { screenDefinitions };
